import { React, useState, useRef } from "react";
import ReactDOM from "react-dom/client";
import { useSelector, useDispatch } from "react-redux";
import { createAccount } from "../../actions/account";
import { useNavigate } from "react-router-dom";
import { loginUrl, uniIdLoginUrl } from "../../common/url";
import { restPostApi } from "../../services/httpService";
import { httpSuccess, success } from "../../common/errorCode";
import "../../assets/css/main.css";
import { CLIENTID } from "../../common/constant";
import { loginSession } from "../../actions/session";
import { loginByUniId } from "../../common/utils";
import { store } from "../..";

const errorStyle = {
  color: "red",
};

const LoginPage = () => {
  const userNameRef = useRef("");
  const passwordRef = useRef("");
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState("");

  const dispatch = useDispatch();

  let errorMessageShow =
    errorMessage == "" ? (
      <div className="text-center text-c-3" style={errorStyle}></div>
    ) : (
      <div className="text-center text-c-3" style={errorStyle}>
        {errorMessage}
      </div>
    );

  function openUniIdToLogin() {}

  async function loginAction() {
    console.log("userNameRef 👉️", userNameRef.current.value);
    console.log("passwordRef 👉️", passwordRef.current.value);

    let userName = userNameRef.current.value;
    let password = passwordRef.current.value;

    // create account
    let res = await restPostApi(loginUrl, {
      msisdn: userName,
      pass: password,
    });
    console.log("RES component: " + JSON.stringify(res));

    if (res != null) {
      console.log("status: " + res.status);
      if (res.status === httpSuccess) {
        console.log("errorCode: " + res.data.errorCode);
        if (res.data.errorCode === success) {
          // create account
          let accountInfo = {
            accountUser: res.data.data.accountUser,
            regInfos: res.data.data.regInfos,
          };
          dispatch(createAccount(accountInfo));

          let tokenInfo = {
            token: res.data.data.token,
            refreshToken: res.data.data.refreshToken,
          };
          dispatch(loginSession(tokenInfo));

          // const accountGet = useSelector((state) => state.accountReducer);
          // const tokenInfoGet = useSelector((state) => state.sessionReducer);

          // console.log("accountGet: " + JSON.stringify(accountGet));
          // console.log("tokenInfoGet: " + JSON.stringify(tokenInfoGet));

          console.log("errorCode: " + JSON.stringify(store));

          navigate("/home", { replace: true });
        } else {
          console.log("message: " + res.data.message);
          setErrorMessage(res.data.message);
        }
      } else {
        console.log("message: " + res.data);
        setErrorMessage(res.data);
      }
    } else {
      console.log("message: ERROR");
      setErrorMessage("message: ERROR");
    }
  }

  function uniIdLogin() {
    loginByUniId();
  }

  return (
    <div className="main-login">
      <div className="fixed top-[15%] left-[50%] w-full translate-x-[-50%] z-[10]">
        <div className="px-[30px]">
          {/* <img src="../assets/images/title-loading.png" /> */}
          <div className="title-main">UWIN</div>
        </div>
      </div>
      <div className="fixed w-full top-[10%] left-[6%]">
        <img src="../assets/images/coin.png" className="" />
      </div>
      <div className="fixed w-full top-[10%] left-[0%]">
        <img
          src="../assets/images/Frame.png"
          className=""
          style={{ width: "415px" }}
        />
      </div>
      <div className="fixed w-full top-[30%] left-[60%]">
        <img src="../assets/images/coin_3.png" className="" />
      </div>
      <div className="fixed z-[1] w-full blend-mode top-[18%] left-[6%]">
        <img src="../assets/images/Light.png" className="blink-effect" />
      </div>
      <div className="fixed z-[20] w-full blend-mode top-[23%] left-[23%]">
        <img src="../assets/images/Light.png" className="blink-effect" />
      </div>
      <div className="fixed z-[20] w-full blend-mode top-[18%] left-[70%]">
        <img src="../assets/images/Light.png" className="blink-effect" />
      </div>
      <div className="w-full h-screen relative ">
        <div className="form-container bg-color-1">
          <div className="w-full h-[64px] bg-linear-1 flex justify-center items-center">
            <div className="text-c-2">Login</div>
          </div>
          <div className="pt-[30px]" onClick={openUniIdToLogin()}>
            <div
              className="text-center text-c-3"
              style={{ textDecoration: "underline", fontSize: "14px" }}
              onClick={uniIdLogin}
            >
              Use your UniId to login!
            </div>
          </div>
          <div className="pt-[30px] flex justify-center">
            <div className="w-full flex flex-col">
              <input
                className="max-w-[313px] w-full h-[47px] bg-[#251829] rounded-[20px] px-[15px] py-[24px]  text-placeholder-1 mx-auto mb-[10px]  text-white"
                ref={userNameRef}
                placeholder="Phone number"
              />
              <input
                className="max-w-[313px] w-full h-[47px] bg-[#251829] rounded-[20px] px-[15px] py-[24px]  text-placeholder-1 mx-auto mb-[10px]  text-white"
                ref={passwordRef}
                placeholder="Password"
                type="password"
              />
            </div>
          </div>
          <div className="py-[20px]">{errorMessageShow}</div>
          <div className="flex justify-center" onClick={loginAction}>
            <div className="btn-c-1 text-c-2 font-z-18">LOGIN</div>
          </div>

          <div className="flex justify-center flag-container">
            <div className="text-c-2 font-z-18 flag-style">
              <img src="../assets/images/en_flag.png" />
            </div>
            <div className="text-c-2 font-z-18 flag-style">
              <img src="../assets/images/laos_flag.png" />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-coin-loading">
        <img src="../assets/images/coin-bg.png" />
      </div>
    </div>
  );
};

export default LoginPage;
